module.exports = __webpack_public_path__ + "img/invoice-dzpt.94c0630b.png";